import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsx("path", _objectSpread({
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6C9.44772 6 9 6.44771 9 7V19.1495C9 20.0821 9.4338 20.9618 10.1738 21.5296L16 26L21.8262 21.5296\n       C22.5662 20.9618 23 20.0821 23 19.1495V7C23 6.44772 22.5523 6 22 6H10ZM12 8C11.4477 8 11 8.44772 11 9\n       V10.0971C11 10.4296 11.1653 10.7404 11.441 10.9262L16 14L20.559 10.9262C20.8347 10.7404 21 10.4296 21 10.0971\n       V9C21 8.44772 20.5523 8 20 8H12Z"
  }, args));
};
var ViewBox = "0 0 32 32";
var _FWBackline = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "white" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 32 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: /* @__PURE__ */jsx(Path, {
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth
    })
  }));
});
_FWBackline.displayName = "FWBackline";
var FWBackline = withSubcomponents(_FWBackline, {
  Path: Path,
  ViewBox: ViewBox
});
export { FWBackline };